<template>
  <div>
    <div class="settings-panel">
      <!-- SLIDE MENU PANEL -->
      <div class="slide-out-menu">
        <!-- PANEL ROW -->
        <div
          class="panel-row d-flex justify-content-start align-items-start nowrap"
        >
          <!-- AVATAR -->
          <div
            class="avatar avatar-square avatar_md"
            :class="panel_image ? null : setAvatarBg"
          >
            <img
              v-lazy="panel_image"
              :alt="user_name"
              class="avatar-img"
              v-if="panel_image"
            />
            <div class="avatar-text color_white" :class="setAvatarBg" v-else>
              {{ getInitial }}
            </div>
          </div>

          <!-- AVATAR INFO -->
          <div
            class="d-flex flex-column justify-content-start align-items-start"
          >
            <div class="name color-text font-weight-bold text-capitalize">
              {{ user_name }}
            </div>
            <div class="school color_grey_dark" v-if="panel_type === 'school'">
              {{ school_name }}
            </div>
            <div
              class="school color_grey_dark"
              v-else-if="panel_type === 'student'"
            >
              SC:
              <span class="font-weight-bold text-uppercase">{{
                student_code
              }}</span>
            </div>
            <div class="email color_grey_dark" v-else>{{ email }}</div>
            <router-link
              :to="'/' + panel_type + '/settings'"
              class="update-cta btn-link font-weight-bold"
              >Update Profile</router-link
            >
          </div>
        </div>

        <!-- LIST ITEMS -->
        <div
          class="list-wrapper d-flex flex-column justify-content-start align-items-start"
        >
          <!-- SCHOOL PROFILE -->
          <template v-if="panel_type === 'school'">
            <router-link
              :to="{ name: 'SchoolProfile' }"
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-school border_grey_dark"></span>
              <div class="link-text">School Profile</div>
            </router-link>
          </template>

          <!-- SCHOOL PREFERENCES -->
          <template v-if="panel_type === 'school'">
            <router-link
              :to="'/' + panel_type + '/settings/preferences/school'"
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-sliders border_grey_dark"></span>
              <div class="link-text">School Preferences</div>
            </router-link>
          </template>

          <!-- MY CALENDAR -->
          <template v-if="panel_type === 'school' || panel_type === 'teacher'">
            <router-link
              :to="'/' + panel_type + '/calendar'"
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-calendar border_grey_dark"></span>
              <div class="link-text">My Calendar</div>
            </router-link>
          </template>

          <!-- TUTOR LINK -->
          <template v-if="false">
            <template
              v-if="panel_type === 'parent' || panel_type === 'student'"
            >
              <router-link
                :to="'/' + panel_type + '/tutors'"
                class="list-data d-flex justify-content-start align-items-center nowrap"
              >
                <span class="icon icon-user-circle border_grey_dark"></span>
                <div class="link-text">Find a Tutor</div>
              </router-link>
            </template>
          </template>

          <!-- HELP AND SUPPORT -->
          <template v-if="false">
            <router-link
              to
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-help-circle border_grey_dark"></span>
              <div class="link-text">Help &nbsp; Support</div>
            </router-link>
          </template>

          <template v-if="false">
            <template v-if="panel_type === 'school' || panel_type === 'parent'">
              <a
                :href="referralURL"
                class="list-data d-flex justify-content-start align-items-center nowrap"
              >
                <span class="icon icon-reward-pack border_grey_dark"></span>
                <div class="link-text">
                  Reward
                  <span
                    class="brand_red_bg white-text font-9-5 font-weight-500 rounded-5 px-2 py-1 ml-3"
                    >New</span
                  >
                </div>
              </a>
            </template>
          </template>

          <!-- SWITCH TO PARENT -->
          <template v-if="parent_token">
            <template v-if="panel_type === 'student'">
              <router-link
                to
                @click.native="switchAccountToParent"
                class="list-data d-flex justify-content-start align-items-center nowrap"
              >
                <span class="icon icon-swap border_grey_dark"></span>
                <div class="link-text">Switch to Parent</div>
              </router-link>
            </template>
          </template>
          <!-- SWITCH TO PARENT -->

          <!-- SWITCH TO CHILD -->
          <template v-if="panel_type === 'parent'">
            <router-link
              to
              @click.native="switchAccountToChild"
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-swap border_grey_dark"></span>
              <div class="link-text">Switch to Child</div>
            </router-link>
          </template>
          <!-- SWITCH TO CHILD -->

          <!-- MY ACCOUNT -->
          <template v-if="panel_type === 'school'">
            <router-link
              :to="'/' + panel_type + '/settings/user'"
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-gear border_grey_dark"></span>
              <div class="link-text">My Account</div>
            </router-link>
          </template>

          <template v-else>
            <router-link
              :to="'/' + panel_type + '/settings/preferences'"
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-gear border_grey_dark"></span>
              <div class="link-text">My Account</div>
            </router-link>
          </template>

          <!-- LOG OUT -->
          <template>
            <router-link
              to
              @click.native="logout"
              class="list-data d-flex justify-content-start align-items-center nowrap"
            >
              <span class="icon icon-log-out border_grey_dark"></span>
              <div class="link-text">Log Out</div>
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { REFERRAL_BASE_URL } from "@/var";
import { mapGetters, mapActions } from "vuex";
import { setInitial, generateTokenString } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "SettingsPanel",

  props: {
    user_name: String,
    school_name: String,
    email: String,
    student_code: String,
    panel_image: [String, Boolean],
    panel_type: String,
  },

  computed: {
    ...mapGetters(["getSelectedChildID", "getAuthToken"]),

    getInitial() {
      return setInitial(this.user_name);
    },

    setAvatarBg() {
      return setProfileBg(this.user_name);
    },

    referralURL() {
      return `${REFERRAL_BASE_URL}/${generateTokenString(this.getAuthToken)}`;
    },
  },

  data() {
    return {
      parent_token: localStorage.getItem("parentToken"),
    };
  },

  methods: {
    ...mapActions(["logoutUser", "parentToChildAccount"]),

    switchAccountToParent() {
      localStorage.gradelyAuthToken = localStorage.getItem("parentToken");
      localStorage.authUser = localStorage.getItem("parentUser");
      localStorage.switchDone = 1;

      delete localStorage.parentToken;
      delete localStorage.parentUser;

      let current_route = this.$router.currentRoute.name;

      if (current_route === "StudentHomework") {
        setTimeout(() => {
          this.$router.push({
            name: "ParentHomework",
            params: { id: this.getSelectedChildID },
          });
        }, 1500);
      } else if (current_route === "StudentCatchup") {
        setTimeout(() => {
          this.$router.push({
            name: "ParentCatchup",
            params: { id: this.getSelectedChildID },
          });
        }, 1500);
      } else {
        setTimeout(() => {
          this.$router.push({
            name: "ParentFeeds",
            params: { id: this.getSelectedChildID },
          });
        }, 1500);
      }
    },

    switchAccountToChild() {
      this.parentToChildAccount(this.getSelectedChildID)
        .then((response) => {
          if (response.code === 200) {
            localStorage.parentToken = localStorage.getItem("gradelyAuthToken");

            localStorage.parentUser = localStorage.getItem("authUser");
            localStorage.gradelyAuthToken = response.data.token;
            this.$store.commit("AUTH_SUCCESS", response.data);

            localStorage.switchDone = 1;

            let current_route = this.$router.currentRoute.name;
            if (current_route === "ParentHomework") {
              setTimeout(() => {
                this.$router.push({
                  name: "StudentHomework",
                  params: { id: this.getSelectedChildID },
                });
              }, 1500);
            } else if (current_route === "ParentFeeds") {
              setTimeout(() => {
                this.$router.push({
                  name: "StudentFeeds",
                  params: { id: this.getSelectedChildID },
                });
              }, 1500);
            }
          }
        })
        .catch((err) => console.log(err));
    },

    logout() {
      this.$bus.$emit("event-bus-logout-user");
      this.logoutUser()
        .then(() => setTimeout(() => (location.href = "/login"), 1500))
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
.settings-panel {
  position: fixed;
  top: 50px;
  right: 6px;
  width: 320px;
  z-index: 2000;
  transition: all 0.4s ease-in-out;
  animation: panel-slide-right 0.45s ease-in-out forwards;

  @include breakpoint_max(lg) {
    width: 300px;
  }

  @include breakpoint_max(md) {
    right: 100%;
    left: 6px;
    animation: panel-slide-left 0.3s ease-in-out forwards;
  }

  @include breakpoint_max(sm) {
    width: 250px;
    left: 14px;
  }

  .slide-out-menu {
    @include breakpoint_max(sm) {
      padding: 15px 15px 0;
    }
  }

  .avatar {
    margin-right: 15px;

    @include breakpoint_max(sm) {
      margin-right: 10px;
      @include equal_min_edge(34);
    }

    .avatar-text {
      font-size: 16px;

      @include breakpoint_max(lg) {
        font-size: 14px;
      }

      @include breakpoint_max(sm) {
        font-weight: 600 !important;
        font-size: 13px;
      }
    }
  }

  .name {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 4px;
    letter-spacing: 0.02em;

    @include breakpoint_max(lg) {
      font-size: 14px;
    }

    @include breakpoint_max(sm) {
      margin-bottom: 1px;
      font-size: 13px;
    }
  }

  .school,
  .email {
    font-size: 13px;
    line-height: 18px;
    margin-bottom: 10px;

    @include breakpoint_max(lg) {
      font-size: 12px;
    }

    @include breakpoint_max(sm) {
      margin-bottom: 7px;
      font-size: 11px;
    }
  }

  .update-cta {
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;

    @include breakpoint_max(lg) {
      font-size: 12px;
    }

    @include breakpoint_max(sm) {
      font-size: 11px;
    }
  }

  .list-wrapper {
    margin-bottom: 20px;

    @include breakpoint_max(sm) {
      margin-bottom: 10px;
    }
  }

  .list-data {
    display: block;
    width: 100%;
    padding: 15px 10px;
    transition: all 0.4s ease-in-out;

    &:hover {
      background: rgba($brand_inverse, 0.15);
      color: $brand_black;
    }

    @include breakpoint_max(sm) {
      margin-left: -5px;
    }

    .icon {
      display: block;
      margin-right: 15.78px;
      font-size: 24px;

      @include breakpoint_max(sm) {
        font-size: 18px;
        margin-right: 14.5px;
        margin-top: -1px;
      }
    }

    .link-text {
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.02em;
      color: $color_ash;

      @include breakpoint_max(lg) {
        font-size: 12px;
      }

      @include breakpoint_max(sm) {
        letter-spacing: 0.01em;
        font-size: 11.5px;
      }
    }
  }
}
</style>
